import { Box } from '@mui/material';

import locales from '../../../../../../../constants/locales';

const ExpiredEvents = () => <Box textAlign="center">{locales.billing.details.events.voiceSessionExpired}</Box>;

export default ExpiredEvents;
